module.exports = __webpack_public_path__ + "media/images/media_image-6ae52c8e7d8bdbc46049f5aa37e9ed94.svg";